import HTTP from "../../../services/HTTP.js";
// Login User
export const login = async (credentials) => {
  const res = await HTTP.post('/auth/login', credentials);
  return res.data;
};

// Register user
export const register = async (userData) => {
  const res = await HTTP.post('auth/register', userData);
  return res.data;
};

// Logout user
export const logoutUser = async (email) => {
  const res = await HTTP.post('/auth/logout/', { email });
  return res.data;
};


// forgot password
export const forgotPassword = async (email) => {
  const res = await HTTP.post('/auth/forgot-password', { email });
  return res.data;
};


// reset password
export const resetPassword = async (token, password) => {
  const res = await HTTP.post(`/auth/reset-password/${token}`, {
        password,
      });
  return res.data;
};
